import Dispatcher from "../dispatcher";

var NavigatorStore = {
  _state: {
    routeStack: []
  },

  get() {
    return this._state.routeStack;
  },

  _updateState(state) {
    this._state = Object.assign({}, this._state, state);
    Dispatcher.emit(Dispatcher.NAVIGATOR_STATE_CHANGE);
  },

  _silentUpdate(state) {
    this._state = Object.assign({}, this._state, state);
  },

  init() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 5);

    Dispatcher.bind(Dispatcher.NAVIGATOR_POP, () => {
      const routeStack = this._state.routeStack;
      routeStack.pop();
      this._updateState({ routeStack });
    });

    Dispatcher.bind(Dispatcher.NAVIGATOR_PUSH, (route, props) => {
      props = props || {};
      const routeStack = this._state.routeStack;
      routeStack.push({ route, props });
      this._updateState({ routeStack });
    });

    Dispatcher.bind(
      Dispatcher.NAVIGATOR_REPLACE_LAST,
      (route, props, silent) => {
        props = props || {};
        const routeStack = this._state.routeStack;
        routeStack.pop();
        routeStack.push({ route, props });
        if (silent) {
          this._silentUpdate({ routeStack });
        } else {
          this._updateState({ routeStack });
        }
      }
    );

    Dispatcher.bind(Dispatcher.NAVIGATOR_REPLACE, (route, props) => {
      props = props || {};
      const routeStack = [{ route, props }];
      this._updateState({ routeStack });
    });

    Dispatcher.bind(Dispatcher.NAVIGATOR_RESET, () => {
      this._silentUpdate({ routeStack: [] });
    });
  }
};

NavigatorStore.init();

export default NavigatorStore;
